import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import Palette from '@/styles/Themes/Palette';

export const VStickyFooterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    height: 70px;
    background-color: ${Palette.blue.normal};
    border-radius: 15px 15px 0px 0px;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: ${cssVars.shadow_card_default};
    z-index: 3;

    ${Screen.ipad} {
        height: 65px;
    }

    ${Screen.desktop} {
        height: 80px;
    }
`;

export const VFooterContent = styled.div`
    display: flex;
    position: absolute;
    bottom: 0;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    width: 90%;
    height: 100%;
    transition: 0.3s all;

    ${Screen.desktop} {
        max-width: 1064px;
    }
`;

export const VRatingSection = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    flex-direction: column;
    max-width: 60%;
    color: ${Palette.white.normal};
    ${Text.Full.large.medium};
    min-height: 48px;

    > a {
        display: block;
        ${Text.Mobile.large.medium};
        text-decoration: underline;
    }

    ${Screen.ipad} {
        justify-content: center;
        > a {
            ${Text.Ipad.medium.medium}
        }
    }
    ${Screen.desktop} {
        > a {
            ${Text.Desktop.large.medium}
        }

        > div {
            margin: 5px 0;
        }
    }
`;

export const VTitle = styled.span`
    ${Text.Mobile.small.semibold};
    color: ${cssVars.fg_black_white};

    ${Screen.ipad} {
        ${Text.Ipad.large.semibold};
    }
`;

export const VButtonSection = styled.div`
    display: flex;
    align-items: center;

    > button {
        ${Text.Full.large.medium};
        padding: 4px 24px;
        min-height: 36px;

        ${Screen.desktop} {
            min-width: max-content;
            min-height: 48px;
        }
    }

    ${Screen.ipad} {
        ${Text.Ipad.large.medium};
        margin-left: 12px;
    }

    ${Screen.desktop} {
        ${Text.Desktop.medium.medium};
    }
`;
